import './search-form.scss';
import React from 'react';
import PropTypes from 'prop-types';
import { getConfig } from '@edx/frontend-platform';
import classNames from 'classnames';

const SearchForm = ({ placeholder, className }) => (
  <form
    action={getConfig().CATALOG_URL}
    name="search"
    autoComplete="false"
    className={classNames('search-form ', className)}
  >
    <input
      className="search-form-text"
      name="search"
      maxLength={255}
      placeholder={placeholder}
    />
    <button className="search-icon" type="submit" />
  </form>
);

SearchForm.propTypes = {
  placeholder: PropTypes.string,
  className: PropTypes.string,
};

SearchForm.defaultProps = {
  placeholder: undefined,
  className: undefined,
};

export default SearchForm;
